export default __webpack_public_path__ + "static/media/music.d1beaff4.jpg";